import {Injectable} from '@angular/core';
import {HttpInterceptorService, RESTService} from '@covalent/http-deprec';
import {Lieferung} from './Model/Lieferung';
import {environment} from '../../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TeilpaketKraft } from './Model/TeilpaketKraft';


@Injectable()
export class MaklerPaketStatusService extends RESTService<Lieferung> {

  constructor(
    public http: HttpInterceptorService
  ) {
    super(http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/getMaklerPaketStatus'
    });
  }

  getPaketStatus(wert: string, von : any, bis: any): Observable<any> {
    let vonIso =von.toISOString().split(".");
    let bisIso =bis.toISOString().split(".");
    let formData: FormData = new FormData();
    formData.append("wert", wert);
    formData.append("von", vonIso[0]);
    formData.append("bis", bisIso[0]);
    return this.http.post(`${environment.apiHost}` + '/makpak/getMaklerPaketStatus', formData, { withCredentials: true }).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }));}
}
